import PropTypes from 'prop-types';
import React from 'react';

var propTypes = {
  labels: PropTypes.objectOf(PropTypes.string),
  value: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};
var defaultProps = {
  labels: {},
  value: null,
  placeholder: null
};
var Label = function Label(_ref) {
  var labels = _ref.labels,
    value = _ref.value,
    placeholder = _ref.placeholder;
  return /*#__PURE__*/React.createElement("div", null, labels[value] || value || placeholder);
};
Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

export { Label as default };
